import { render, staticRenderFns } from "./damage-waiver.vue?vue&type=template&id=f7047536&scoped=true"
import script from "./damage-waiver.vue?vue&type=script&lang=js"
export * from "./damage-waiver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7047536",
  null
  
)

export default component.exports